import { useEffect } from 'react';

interface PageMetadataProps {
  title?: string;
  description?: string;
}

/**
 * Component to set page metadata (title and description)
 * Simple alternative to react-helmet-async for React 19 compatibility
 */
export default function PageMetadata({ title, description }: PageMetadataProps) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  useEffect(() => {
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', description);
    }
  }, [description]);

  return null;
}

